import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchCompetencesPageAction } from './actions/fetchCompetencesPage';

import {CompetencesPage} from './competencesPage';

const mapStateToProps = (state: IState) => ({
    competencesContentPage: state.mainContent.competencesPageItem
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchCompetencesPage: () => dispatch(fetchCompetencesPageAction())
});

export const CompetencesPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompetencesPage);


// WEBPACK FOOTER //
// ./src/components/competencesPage/competencesPageContainer.tsx